<template>
  <b-row class="mb-5">
    <b-col v-for="step in steps" :key="step">
      <b-progress-bar :class="`w-100 bar ${currentStep < step ? 'empty' : 'filled'}`"></b-progress-bar>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'FundMapStepper',
  data: function() {
    return {
      steps: [1, 2, 3]
    }
  },
  props: {
    currentStep: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.bar {
  height: 9px;
  border-radius: 4px;
}
.filled {
  background-color: #00903c;
}
.empty {
  background-color: #dfe6e9;
}

@media all and (max-width: 391px) {
  .bar {
    height: 6px;
  }
}
</style>
